import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonRow,
  IonCol,
  IonIcon,
  IonPopover,
  IonItemDivider,
  IonItem,
  IonInput,
  IonLabel
} from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Preset.css';
import IPreset from '../interfaces/IPreset';


/*ICONS */
import { addCircle } from 'ionicons/icons';
import { chevronBackCircle } from 'ionicons/icons';
import { save } from 'ionicons/icons';
import { close } from 'ionicons/icons';


const Preset: React.FC = () => {
  var history = useHistory();

  const [AddRowPreset, setAddRowPreset] = useState<boolean>(false);
  const [cielo, setCielo] = useState<number>();
  const [platea, setPlatea] = useState<number>();

  const [elencoPreset, setElencoPreset] = useState<Array<IPreset>>([]);


  useEffect(() => {

    var dati: Array<IPreset> = [
      {
        nome: 'Preriscaldamento',
        cielo: 70,
        platea: 30,
        setpoint: 350
      },
      {
        nome: 'Pizza',
        cielo: 70,
        platea: 30,
        setpoint: 350
      },
      {
        nome: 'Pizza 2',
        cielo: 70,
        platea: 30,
        setpoint: 350
      }

    ]

    setElencoPreset(dati);

  }, []);


  return (
    <>
      <IonPage >
        <ExploreContainer name="Home page" />

        <IonHeader style={{ height: "6%" }}>

          <IonToolbar style={{ height: "100%" }} class={'host'}>
            <IonRow style={{ height: "100%" }}>
              <IonCol size="2" >
                <IonButton onClick={() => { history.push("/Impostazioni") }} fill="clear" style={{ height: "auto" }}>
                  <IonIcon icon={chevronBackCircle} style={{ color: "white", fontSize: "50px" }}></IonIcon>
                </IonButton>
              </IonCol>
              <IonCol size="8" >
                <IonTitle style={{ fontSize: "30px", textAlign: "center", fontFamily:"Bahnschrift"}}>Preset</IonTitle>
              </IonCol>
              <IonCol size="2" >
                <IonButton onClick={() => { setAddRowPreset(true) }} fill="clear" style={{ height: "auto" }}>
                  <IonIcon icon={addCircle} style={{ color: "white", fontSize: "50px" }}></IonIcon>
                </IonButton>
              </IonCol>
            </IonRow>
          </IonToolbar>

        </IonHeader>

        <IonContent class={'background-content'} fullscreen >

          <IonRow class={'righePreset'} style={{marginTop:"40px"}}>

            <IonCol size="4"  style={{  paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "#a2282a",color:"white" }}> <div style={{ textAlign: "left" }}>Nome</div></IonCol>

            <IonCol  size="2" style={{ paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "#a2282a",color:"white" }}> <div style={{ textAlign: "left" }}>%Cielo</div></IonCol>

            <IonCol size="2"  style={{  paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "#a2282a",color:"white" }}><div style={{ textAlign: "left" }} >%Platea</div> </IonCol>

            <IonCol  size="3"  style={{  paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "#a2282a",color:"white" }}> <div style={{ textAlign: "left" }}>Setpoint</div></IonCol>
          </IonRow>


    { elencoPreset.map(preset =>
          <IonRow class={'righePreset'}>

            <IonCol size="4" class={'borderTab'} style={{ borderLeft:"2px solid gray",paddingTop: "15px", paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "white" }}> <div style={{ textAlign: "left" }}>{preset.nome}</div></IonCol>

            <IonCol size="2"  class={'borderTab'}style={{ paddingTop: "15px", paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "white" }}> <div style={{ textAlign: "left" }}>{preset.cielo}</div></IonCol>

            <IonCol  size="2" class={'borderTab'} style={{ paddingTop: "15px", paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "white" }}><div style={{ textAlign: "left" }} >{preset.platea}</div> </IonCol>

            <IonCol  size="3"  style={{ borderRight:"2px solid gray",borderBottom:"2px solid gray", paddingTop: "15px", paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "white" }}> <div style={{ textAlign: "left" }}>{preset.setpoint}°</div></IonCol>

          </IonRow>
    )}






        </IonContent>

      </IonPage>




      <IonPopover class={'pop'} style={{ size: "auto" }} isOpen={AddRowPreset} onDidDismiss={()=>{ setAddRowPreset(false)}}>

        <IonLabel style={{ backgroundColor: "#a2282a", color: "white", fontSize: "25px", paddingleft: "7%", paddingTop: "5px", paddingBottom: "10px", textAlign: "center",fontFamily:"Bahnschrift" }}>Aggiungi Preset</IonLabel>
        <IonRow >

            <IonCol size="3" style={{ paddingTop: "15px",color: "#a2282a", paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "white" }}> <div style={{ textAlign: "left" ,paddingTop:"15px ",fontFamily:"Bahnschrift"}}><b>Nome</b></div></IonCol>

            <IonCol size="8" style={{paddingTop:"25px"}}>
              <IonInput style={{borderTop: "1px solid gray", borderLeft:"1px solid gray",fontSize: "20px", textAlign: "left", height: "50px", width: "100%" }} class={"MenuPopSetp"} type="text"></IonInput>
            </IonCol>
        </IonRow>

        <IonRow >

            <IonCol size="3" style={{ paddingTop: "15px",color: "#a2282a", paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "white" }}> <div style={{ textAlign: "left",fontFamily:"Bahnschrift" }}><b>% Cielo</b></div></IonCol>

            <IonCol size="8">
              
              <IonInput style={{borderTop: "1px solid gray", borderLeft:"1px solid gray",fontSize: "20px", textAlign: "left", height: "50px", width: "100%" }} class={"MenuPopSetp"} type="number" value={cielo} onIonChange={(e) => { setCielo(parseInt(e.detail.value!, 10)) }}></IonInput>
             
            </IonCol>
        </IonRow>

        <IonRow>

            <IonCol size="3" style={{ paddingTop: "15px",color: "#a2282a", paddingLeft: "10px", height: "15%", fontSize: "30px", backgroundColor: "white" }}> <div style={{ textAlign: "left",fontFamily:"Bahnschrift" }}><b>% Platea</b></div></IonCol>

            <IonCol size="8" >
              <IonInput style={{ borderTop: "1px solid gray",borderLeft:"1px solid gray",fontSize: "20px", textAlign: "left", height: "50px", width: "100%" }} class={"MenuPopSetp"} type="number" value={platea} onIonChange={e => setPlatea(parseInt(e.detail.value!, 10))}></IonInput>
            </IonCol>
        </IonRow>

        <IonRow >

            <IonCol size="3" style={{ paddingTop: "15px",color: "#a2282a", paddingLeft: "10px", height: "15%", fontSize: "30px"}}> <div style={{ textAlign: "left",fontFamily:"Bahnschrift" }}><b>Setpoint</b></div></IonCol>

            <IonCol size="8" style = {{}}>
              <IonInput style={{ borderTop: "1px solid gray",borderLeft:"1px solid gray", fontSize: "20px", textAlign: "left", height: "50px", width: "100%" }} class={"MenuPopSetp"} type="text"></IonInput>
            </IonCol>
        </IonRow>


          <IonRow >
          <IonCol size="3" style={{ alignItems: "left" }} >
            <IonButton onClick={() => { setAddRowPreset(false) }} fill="clear" style={{ height: "60px", color: "white", background: "red", width: "80%" }}>
              <IonIcon icon={close} style={{ color: "white", fontSize: "50px" }}></IonIcon>
              ANNULLA</IonButton>
          </IonCol>
          
          <IonCol size="3" style={{ alignItems: "right" }}>
            <IonButton onClick={() => { }} fill="clear" style={{ height: "60px", color: "white", background: "green", width: "80%" }}>
              <IonIcon icon={save} style={{ color: "white", fontSize: "50px" }}></IonIcon>

              SALVA</IonButton>
          </IonCol>
          </IonRow>
      </IonPopover>

    </>
  );
};

export default Preset;
